var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 445,
    height: 500,
    viewBox: "0 0 445 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M444.446 0L402.773 451.385L222.22 500L41.6646 451.385L0 0H444.446ZM360.472 91.7822H222.058H81.1911L87.9279 146.291H222.058H229.592L222.058 149.427L92.8301 203.249L97.1159 256.53L222.058 256.935L289.023 257.148L284.736 328.191L222.057 345.838V345.782L221.543 345.925L161.01 330.644L157.337 286.544H157.137H100.99H100.792L108.141 371.679L222.059 405.367V405.306L222.264 405.367L335.571 372.292L350.269 203.249H222.059H221.743L222.059 203.112L354.965 146.291L360.472 91.7822Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.46ad5d8c1261c2ee2ac1c1fad63e468a.svg";
export { ForwardRef as ReactComponent };